import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenue !");
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-zinc-900 border border-white/10 rounded-md px-4 py-3 text-white placeholder-zinc-500 focus:border-yellow-400 focus:outline-none";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090B] px-6">
      <div className="grain" />
      <div className="relative w-full max-w-md bg-zinc-900/70 backdrop-blur-xl border border-white/10 rounded-2xl p-8">
        <div className="w-12 h-12 rounded-xl bg-yellow-400 flex items-center justify-center mb-6">
          <Lock className="text-black" />
        </div>
        <h1 className="font-display text-3xl font-black tracking-tight mb-1 text-white">Espace admin</h1>
        <p className="text-zinc-400 text-sm mb-8">Black Lemon Studio — Back-office</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={inputCls} required />
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mot de passe" className={inputCls} required />
          <button data-testid="login-submit" disabled={loading} className="w-full flex items-center justify-center gap-2 bg-yellow-400 text-black font-bold py-3 rounded-md hover:bg-yellow-300 disabled:opacity-60 transition-colors">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Se connecter
          </button>
        </form>
      </div>
    </div>
  );
}
